import { withMotion } from '../hoc/with-motion';
import { UserDetailPage } from '@/modules/support/components/user-detail/page';

const AnimatedPage = withMotion(UserDetailPage);

export const roles: string[] = ['super-admin', 'supporter'];
export const path = '/support/user/:userId';
export const element = <AnimatedPage />